// Conta dialogs "acessórios" (sem .crm-root-modal nem .atendimento-inner-modal)
// no DOM. Vuetify 2 pode aplicar `content-class` no proprio `.v-dialog__content`
// ou em algum descendente — checamos as duas formas pra cobrir ambos os
// cenarios (modal raiz vs modal aberto de dentro de outro modal).
export function countNonRootDialogs(dialogs) {
  let count = 0
  for (const d of dialogs) {
    const hasClass =
      d.classList.contains('crm-root-modal') ||
      !!d.querySelector('.crm-root-modal') ||
      d.classList.contains('atendimento-inner-modal') ||
      !!d.querySelector('.atendimento-inner-modal')
    if (!hasClass) count += 1
  }
  return count
}

// Retorna o MAIOR z-index entre todos os dialogs ativos. Quando há vários
// modais empilhados (ex: register-relationship aberto de dentro de lead-steps),
// precisamos ficar acima do topo da pilha — usar minZ+1 colocava o popup
// entre modais.
export function maxDialogZ(dialogs) {
  let maxZ = -Infinity
  for (const dialog of dialogs) {
    const z = Number.parseInt(window.getComputedStyle(dialog).zIndex, 10)
    if (!Number.isNaN(z) && z > maxZ) maxZ = z
  }
  return maxZ
}
